var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},_vm.$listeners),[_c('path',{attrs:{"d":"m8.71 11.71 2.59 2.59a1 1 0 0 0 1.41 0l2.59-2.59a1 1 0 0 0-.71-1.71H9.41a1 1 0 0 0-.7 1.71"}})])}
var staticRenderFns = []

export { render, staticRenderFns }